import React from 'react'
import { useProject } from '@/app/routes/Dashboard/Dashboard.hooks'
import {
  ConnectorStep,
  SecretStep,
  TemplateStepType,
  SummaryStep,
  ZendeskCustomObjectKeyStep,
  ZendeskCustomObjectFieldStep,
  ZendeskTicketFieldStep,
} from '@/features/templates'
import Typography from '@/components/ui/Typography'
import { SlackNotificationsViewsConfigStep } from '../SlackNotificationsViewsConfigStep'

export type TemplateStepProps = { step: TemplateStepType; templateId: number }

export const TemplateStep = ({ step, templateId }: TemplateStepProps) => {
  const [project] = useProject()

  if (step.type === 'connector') {
    return <ConnectorStep name={step.data.key} requirement={step.data} />
  }

  if (step.type === 'secret') {
    return <SecretStep name={step.data.key} requirement={step.data} projectId={project.id!} />
  }

  if (step.type === 'summary') {
    return <SummaryStep templateId={templateId} />
  }

  if (step.type === 'zendesk_custom_object_key') {
    return <ZendeskCustomObjectKeyStep name={step.data.key} requirement={step.data} />
  }

  if (step.type === 'zendesk_custom_object_field') {
    return <ZendeskCustomObjectFieldStep name={step.data.key} requirement={step.data} />
  }

  if (step.type === 'zendesk_ticket_field') {
    return <ZendeskTicketFieldStep name={step.data.key} requirement={step.data} />
  }

  if (step.type === 'zendesk_ticket_field_lookup') {
    return <ZendeskTicketFieldStep name={step.data.key} requirement={step.data} types={['lookup']} />
  }

  if (step.type === 'template_slack_notifications_views_config') {
    return <SlackNotificationsViewsConfigStep name={step.data.key} requirement={step.data} />
  }

  // TODO Add fallback inputs for Zendesk

  return <Typography>No step</Typography>
}
